import $ from 'jquery';
import { component as defineComponent } from 'flightjs';
import withAsyncValidation from 'launch/modules/mixins/with-async-validation';
import Spinner from 'app/modules/button-spinner';
import { get as getCookie } from 'cookies-js';

var lang = {
    enterEmail: 'Please enter an email address',
    enterPassword: 'Please enter a password',
    error: 'Invalid email or password',
};

function LoginForm() {
    this.attributes({
        submitSelector: '[type="submit"]',
        emailSelector: '#loginform_email',
        passwordSelector: '#loginform_password',
    });

    this.submitClicked = function(e) {
        e.preventDefault();
        this.resetValidationErrors();

        var $email = this.select('emailSelector');
        var $password = this.select('passwordSelector');

        if (!$email.val()) {
            this.displayErrorsForField($email, lang.enterEmail);
            return;
        }

        if (!$password.val()) {
            this.displayErrorsForField($password, lang.enterPassword);
            return;
        }

        this.trigger('spinnerStart');

        var data = {
            email: $email.val(),
            password: $password.val(),
            csrf_token: getCookie('_99csrf'),
        };

        if ($.jqbrowser) {
            data.browser = $.jqbrowser.browser();
            data.browserversion = $.jqbrowser.version.string();
            data.operatingsystem = $.jqbrowser.OS();
        }

        data.screenresolution = screen.width + 'x' + screen.height;
        data.timezoneoffset = new Date().getTimezoneOffset();

        this.trigger('uiUserAuthenticationRequested', data);
    };

    this.handleAuthenticationSuccess = function() {
        this.trigger('spinnerStop');
        this.trigger('loginSuccessful');
    };

    this.handleAuthenticationFailure = function() {
        var $email = this.select('emailSelector');
        this.trigger('spinnerStop');

        this.displayErrorsForField($email, lang.error);
    };

    this.prePopulateEmail = function(e, data) {
        this.select('emailSelector').val(data.value);
    };

    this.after('initialize', function() {
        Spinner.attachTo(this.select('submitSelector'));

        this.on('click', {
            submitSelector: this.submitClicked,
        });

        this.on(document, 'uiBriefEmailBeforeSignupChanged', this.prePopulateEmail);
        this.on(document, 'dataUserAuthenticationSuccess', this.handleAuthenticationSuccess);
        this.on(document, 'dataUserAuthenticationFailure', this.handleAuthenticationFailure);
    });
}

export default defineComponent(LoginForm, withAsyncValidation);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/login-form.js